import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_oDYSyknItqiS: {
	id: 'prd_oDYSy2DEV2knItqiS'
	ident: 'prd_oDYSyknItqiS'
	sku: 'simple_premium_1w_5_71_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_g6xKM2DEV2m7bNVS2'
			amount: 22
			amount_usd: 5.71
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 5.71
			discount: 16.29
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_Brp2B2DEV2oUQLUSt'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_oDYSyknItqiS, SubscriptionProduct>
const prd_oDYSyknItqiS = { ident: 'prd_oDYSyknItqiS' } as typeof _prd_oDYSyknItqiS

export default prd_oDYSyknItqiS
